module.exports = __webpack_public_path__ + "static/img/help-center.9758f857.svg";